//
import { required } from "@/services/validations"
import BranchOfficeModel from "@/models/General/GBranchOffice"
import FamilyModel from "@/models/Warehouse/WhFamily"
import SubfamilyModel from "@/models/Warehouse/WhSubfamily"
import TagModel from "@/models/Warehouse/WhTag"
import UnitOfMeasurementModel from "@/models/Warehouse/WhUnitOfMeasurement"
import ProductHeaders from './headers'
//
import MdlProduct from '@/models/Warehouse/WhProduct'
import ProductsFilters from './products/filter'
import ProductsHeaders from './products/headers'
//import ProductStockHeaders from "./headers"

//
export default (branchId = 0, upcCodes= [],subfamily=[],triggerSubFamily) =>  [
    {
        name: "upc_codes",
        type: "combobox",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            items: upcCodes,
            label: "UPC",
            multiple: true,
            noDataText: "Sin códigos UPC.",
            rules: [ required ],
            //noSubmit: true,
        },
    },
    {
        name: "internal_code",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Código interno",
            rules: [ required ],
        },
    },
    {
        name: "name",
        type: "text-field",
        flex: {
            sm6: true,
        },
        props: {
            label: "Nombre",
            rules: [ required ],
        },
    },
    {
        name: "alias_name",
        type: "text-field",
        flex: {
            sm6: true,
        },
        props: {
            label: "Alias",
            rules: [ required ],
        },
    },
    {
        name: "wh_family_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "family",
            itemValue: "id",
            label: "Familia",
            model: FamilyModel,
            noObject: true,
            rules: [ required ],
        },
        trigger: triggerSubFamily,
    },
    {
        name: "wh_subfamily_id",
        type: "autocomplete",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "subfamily",
            itemValue: "id",
            label: "Sub familia",
            items:subfamily,
            //model: SubfamilyModel,
            noObject: true,
            paramSearch: "subfamily",
            rules: [ required ],
        },
    },
    {
        name: "description",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Descripción",
        },
    },
    {
        name: "tags",
        type: "autocomplete-model",
        flex: {
            sm6: true,
        },
        props: {
            chips: true,
            itemText: "tag",
            itemValue: "id",
            label: "Etiquetas",
            loadingText: "Cargando etiquetas...",
            model: TagModel,
            noDataText: "Sin etiquetas.",
            multiple:true,
            noObject:true,
        },
    },
    {
        props: {title:'Productos promoción'},
        type: 'section-field',
        flex: {
            xs12: true,
            'mb-3': true,
        },
    },
    {
        name: 'products',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: ProductHeaders,
            noActions: true,
            noDataText: 'Sin sucursales.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            
            showNativePagination: true,
            showPicker: true,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: 'Detalle productos seleccionados para promoción',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            pickerProps:{
                filters: ProductsFilters,
                headers: ProductsHeaders,
                service: MdlProduct,
                mapper: (row) => {
                    row[ "quantity" ] = 1
                    row.branchOfficeId = branchId
                    return row
                },
            }
        },
    },    
]

//

//
// export default [
//     {
//         title: "general",
//         fields: generalFields,
//     },
//     {
//         title: "Inventario",
//         fields: inventoryFields,
//     },
// ]